import { BaseRouteService } from 'core/services';

class AreaOfCareRouteService extends BaseRouteService {
    constructor() {
        super('areas-of-care');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }
}

export default AreaOfCareRouteService;
